import { render } from "./App.vue?vue&type=template&id=02328291"
const script = {}

import "./App.vue?vue&type=style&index=0&id=02328291&lang=less"

import exportComponent from "D:\\lmb\\huake-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__